
<script>
    export let label;
    export let required = false;
    export let hasError = null;
    export let requiredError = null;
</script>

<style>
    label {
        font-family: Roboto Condensed, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 120%;
        text-transform: uppercase;
    }
    label .error {
        color: var(--order-error-label-color);
    }
    @media (min-width: 768px) {
        .input-group label {
            font-size: 24px;
        }
    }
</style>

<label>
    { label }
    {#if (required)}
        {#if (hasError)}<span class="error">{ requiredError }</span>{:else}*{/if}
    {/if}
</label>
